import { render, staticRenderFns } from "./LatestReview.vue?vue&type=template&id=292cc2d6&"
import script from "./LatestReview.vue?vue&type=script&lang=js&"
export * from "./LatestReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports